<template>
  <div>
    <card>
      <div slot="header" class="align-items-center">
        <h5 class="h3 mb-0">Filtros</h5>
        <h6 class="text-uppercase text-muted ls-1 mb">
          Configure quais dados deverão ser listados:
        </h6>
      </div>
      <div class="row">
        <div class="col-md-4 col-sm-12">
          <label class="form-control-label">Cargo</label>
          <multiselect
            v-model="selectedRole"
            :options="roles"
            label="name"
            placeholder="Selecione um cargo"
            :selected-label="'Selecionado'"
            track-by="id"
            @loading="loadingRoles"
            :limit="1"
            :limit-text="limitText"
            :multiple="true"
            :close-on-select="false"
          />
        </div>
        <div class="col-md-4 col-sm-12">
          <label class="form-control-label">Usuário</label>
          <multiselect
            v-model="selectedUser"
            :options="users"
            label="name"
            placeholder="Selecione um usuário"
            :selected-label="'Selecionado'"
            track-by="id"
            @loading="loadingUsers"
            :multiple="true"
            :limit="1"
            :limit-text="limitText"
            :close-on-select="false"
          />
        </div>
        <div class="col-md-4 col-sm-12">
          <label class="form-control-label">Permissão</label>
          <multiselect
            v-model="selectedPermission"
            :options="filteredPermissions"
            label="name"
            placeholder="Selecione uma permissão"
            :selected-label="'Selecionado'"
            track-by="name"
            @loading="loadingPermissions"
            :multiple="true"
            :limit="1"
            :limit-text="limitText"
            :close-on-select="false"
          />
        </div>
      </div>
      <div slot="footer" class="row justify-content-end">
        <base-button type="secondary"class="mr-2 mt-2" @click="clearFilters">Limpar Filtros<i class=""></i></base-button>
        <base-button type="secondary"class="mr-2 mt-2" v-loading="loadingPdf" @click="downloadPdf">Gerar PDF<i class= "far fa-file-pdf"></i></base-button>
        <base-button type="secondary"class="mr-2 mt-2" v-loading="loadingXlsx" @click="downloadExcel">Gerar Excel<i class= "far fa-file-excel"></i></base-button>
        <base-button type="primary" class="mr-2 mt-2" v-loading="loading" @click="emitFilter">Filtrar<i class="fas fa-filter"></i></base-button>
      </div>
    </card>
  </div>
</template>

<script setup>
import { ref, onMounted, computed, defineEmits, watch, defineProps } from 'vue';
import axios from "@/backend/axios/index.js";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";

const emit = defineEmits();
const selectedUser = ref(null);
const selectedRole = ref(null);
const selectedPermission = ref(null);
const users = ref([]);
const roles = ref([]);
const controllerPermissions = ref([]);
const loadingUsers = ref(false);
const loadingRoles = ref(false);
const loadingPermissions = ref(false);
const loadingPdf = ref(false);
const loadingXlsx = ref(false);

const props = defineProps({
 loading: Boolean,
});

const emitFilter = () => {
  const userIds = selectedUser.value ? selectedUser.value.map(user => user.id) : [];
  const roleId = selectedRole.value ?  selectedRole.value.map(role => role.id) : [];
  const permissionIds = selectedPermission.value ?  selectedPermission.value.map(permission => permission.name) : [];

  emit('filter', {
    userIds,
    roleId,
    permissionIds
  });
};
const clearFilters = () => {
  selectedRole.value = [];
  selectedUser.value = [];
  selectedPermission.value = [];
}
watch(selectedRole, () => {
  getUsers( ); 
});
const filteredPermissions = computed(() => {
  return controllerPermissions.value
    .filter(permission => permission.name.toLowerCase())
    .sort((a, b) => a.name.localeCompare(b.name));
});


const getUsers = async () => {
  loadingUsers.value = true;
  const query = { name_only: true, status: true}; 

  if (selectedRole.value) {
    query.q = { role_id: selectedRole.value.map(role => role.id) }; 
  }

  try {
    const response = await axios.get("api/v1/users", {
      params: query
    });
    users.value = response.data || [];
    console.log("Users fetched:", users.value); 
  } catch (error) {
    console.error("[Resports][Permission][Filters][getUsers]", error);
  } finally {
    loadingUsers.value = false;
  }
};

const getRoles = async () => {
  loadingRoles.value = true;
  try {
    const response = await axios.get("api/v1/roles")
    roles.value = response.data.roles || [];
  } catch (error) {
    console.error("[Resports][Permission][Filters][getRoles]", error);
  } finally {
    loadingRoles.value = false;
  }
};

const getControllerPermissions = async () => {
  const currentUser = JSON.parse(localStorage.currentUser);
  const path = `/api/v1/users/${currentUser.id}/permissions`;
  try {
    const response = await axios.get(path, { params: { permissionable_controllers: true } });
    controllerPermissions.value = response.data;
    console.log('para ver se tem id', controllerPermissions.value)
  } catch (error) {
    console.error("[Error][getControllerPermissions]", error);
  }
};

const limitText =(count) => { 
  return `+ ${count}`;
};

const downloadPdf = async () =>{
  loadingPdf.value = true;
  try {
    const response = await axios.get("/api/v1/permissions.pdf", { 
      params: {
        send_pdf: true,
        user_ids: selectedUser.value ? selectedUser.value.map((el) => el.id) : [],
        role_ids: selectedRole.value ? selectedRole.value.map((el) => el.id): [],
        filtered_permissions: selectedPermission.value ? selectedPermission.value.map((el) => el.name) : []
      }, 
      responseType: "arraybuffer"
    })
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.target = "_blank";
    link.setAttribute(
      "download",
      `Permissões.pdf`
    );
    document.body.appendChild(link);
    link.click();
  } catch (error) {
    console.error(error);
    loadingPdf.value = false;
  } finally {
    loadingPdf.value = false;
  }
};

const downloadExcel = async () =>{
  loadingXlsx.value = true;
  try {
    const response = await axios.get("/api/v1/permissions.xlsx", { 
      params: {
        send_pdf: true,
        user_ids: selectedUser.value ? selectedUser.value.map((el) => el.id) : [],
        role_ids: selectedRole.value ? selectedRole.value.map((el) => el.id): [],
        filtered_permissions: selectedPermission.value ? selectedPermission.value.map((el) => el.name) : []
      }, 
      responseType: "arraybuffer"
    })
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.target = "_blank";
    link.setAttribute(
      "download",
      `Permissões.xlsx`
    );
    document.body.appendChild(link);
    link.click();
  } catch (error) {
    console.error(error);
    loadingXlsx.value = true;
  } finally {
    loadingXlsx.value = true;
  }
};

onMounted(() => {
  getUsers();
  getRoles();
  getControllerPermissions();
});
</script>
